import { Community } from "../types/Community";

export const communities: Community[] = [
  // {
  //   id: '',
  //   title: '',
  //   description: '',
  //   link: '',
  //   latitude: 0,
  //   longitude: 0,
  //   country: '',
  //   city: '',
  // },
  {
    id: "casa-satoshi",
    title: "La casa de Satoshi",
    description:
      "La Casa de Satoshi es una comunidad y un espacio físico donde se organizan eventos en la Ciudad de México. Cada mes, organizamos un evento para principiantes en el que hacemos presentaciones ligeras y hay mucho networking, y a veces incluso fiesta. El Bitdevs de la Ciudad de México también se celebra en la Casa de Satoshi cada mes. Somos un espacio de trabajo compartido para empresas y proyectos bitcoin-only.",
    link: "https://luma.com/lacasadesatoshi",
    linkTwitter: "https://x.com/lacasadesatoshi",
    linkEmail: "gustavo@swapido.com",
    latitude: 19.412855,
    longitude: -99.137814,
    country: "México",
    city: "Ciudad de México",
    avatarImage: "/images/community-images/casa-satoshi.jpg",
    backgroundImage: "/images/community-images/casa-satoshi-bg.jpeg",
    squadId: null,
  },
  {
    id: "bitcoin-santa-ana",
    title: "Bitcoin Santa Ana",
    description:
      "Grupo salvadoreño de usuarios de Bitcoin que ha estado promoviendo desde 2023 la adopción de Bitcoin autocustodiado como herramienta de soberanía, el software libre y la privacidad.",
    link: "https://primal.net/p/nprofile1qqsvvznrtyqekjgfzk4nyqwtfyq53xruhp33h7k4gpyr8yuytatr5fclpucxl",
    latitude: 13.98719,
    longitude: -89.55868,
    country: "El Salvador",
    city: "Santa Ana",
    avatarImage: "/images/community-images/bitcoin-santa-ana.jpg",
    backgroundImage: "/images/community-images/bitcoin-santa-ana-bg.jpg",
    squadId: null,
  },
  {
    id: "lago-bitcoin",
    title: "Lago Bitcoin",
    description: "Educando a gente indígena de guatemala sobre bitcoin.",
    link: "https://x.com/LakeBitcoin",
    latitude: 14.70174520049271,
    longitude: -91.20360859723557,
    country: "Guatemala",
    city: "Lago Atitlán, Panajachel",
    avatarImage: "/images/community-images/lago-bitcoin.png",
    backgroundImage: "/images/community-images/lago-bitcoin-bg.jpeg",
    squadId: "el-clan",
    cruzade: true,
    foundation: 2022,
  },
  {
    id: "btc-x-bolivia",
    title: "BtcxBolivia",
    description: "Comunidad bitcoiner de Bolivia.",
    link: "https://t.me/btcxbolivia",
    latitude: -16.497758,
    longitude: -68.141395,
    country: "Bolivia",
    city: "La Paz",
    avatarImage: "/images/community-images/btc-bolivia.jpg",
    squadId: "escuadron-cisne",
    cruzade: true,
  },
  {
    id: "isla-btc",
    title: "La IslaBTC",
    description:
      "Comunidad enfocada en el debate y aprendizaje sobre Bitcoin, surge a partir de la Comunidad Cuba Bitcoin. A través de cursos y encuentros presenciales en La Isla de la Juventud, para ayudar a que más personas conozcan y utilicen bitcoin e incentivar el logro de una economía circular.",
    link: "https://delgado74.github.io/laislabtc/",
    latitude: 21.885807,
    longitude: -82.811984,
    country: "Cuba",
    city: "Nueva Gerona. La Isla de la Juventud",
    avatarImage: "/images/community-images/isla-btc.jpg",
    backgroundImage: "/images/community-images/isla-btc-bg.jpeg",
    squadId: null,
  },
  {
    id: "la-crypta",
    title: "La Crypta",
    description:
      "Comunidad bitcoiner más grande del Mundo. Dedicados al desarrollo, educación y difusión de #Bitcoin 🚀",
    link: "https://lacrypta.ar/",
    linkTwitter: "https://twitter.com/lacryptaok",
    linkEmail: "contact@lacrypta.ar",
    linkDiscord: "https://discord.gg/lacryptaok",
    linkTelegram: "https://t.me/lacryptaok",
    npub: "lacrypta@hodl.ar",
    latitude: -34.56475340390474,
    longitude: -58.443142884727834,
    country: "Argentina",
    city: "Belgrano, CABA",
    avatarImage: "/images/community-images/la-crypta.jpg",
    backgroundImage: "/images/community-images/la-crypta-bg.jpeg",
    squadId: null,
    cruzade: true,
    foundation: 2022,
    peopleCount: "+350",
    lnAddress: "pozo@lacrypta.ar",
  },
  {
    id: "colombiap2p",
    title: "ColombiaP2P",
    description:
      "En ColombiaP2P educamos sobre Bitcoin, Lightning, P2P y Nostr, ejecutamos nodos, maximizamos la privacidad y fomentamos una economía circular entorno a Bitcoin.",
    link: "https://t.me/ColombiaP2P",
    latitude: 4.710988340667508,
    longitude: -74.07211790578529,
    country: "Colombia",
    city: "Bogotá",
    avatarImage: "/images/community-images/colombiap2p.jpg",
    squadId: null,
  },
  {
    id: "satoshi-somos-todos",
    title: "Satoshi Somos Todos",
    description:
      "Bitcoin, educación y libertad. Desde Republica Dominicana para el mundo.",
    link: "https://linktr.ee/SatoshiSomosTodos",
    latitude: 18.498438017905933,
    longitude: -69.79021191557062,
    country: "República Dominicana",
    city: "Santo Domingo",
    avatarImage: "/images/community-images/satoshi-somos-todos.jpeg",
    backgroundImage: "/images/community-images/satoshi-somos-todos-bg.jpeg",
    squadId: "escuadron-libertad",
    cruzade: true,
  },
  {
    id: "bitcoin-ruta-de-las-flores",
    title: "Bitcoin Ruta de las Flores",
    description:
      "Nos entregamos por completo a difundir sobre Bitcoin basandonos en el Whitepaper, donde defendemos la Autocustodia, Soberanía financiera, Privacidad.",
    link: "https://x.com/RutadlasFlores",
    latitude: 13.863732581040944,
    longitude: -89.80212743644057,
    country: "El Salvador",
    city: "Apaneca",
    avatarImage: "/images/community-images/bitcoin-ruta-de-las-flores.jpg",
    backgroundImage:
      "/images/community-images/bitcoin-ruta-de-las-flores-bg.jpeg",
  },
  {
    id: "21-bitcoin-academy",
    title: "21 Bitcoin Academy",
    description:
      "En 21 Bitcoin Academy, te acompañamos a recorrer el camino acelerando tu curva de aprendizaje y poniendo a tu disposición las mejores herramientas y productos del mercado.",
    link: "https://21bitcoinacademy.com/",
    latitude: 9.92844877486275,
    longitude: -84.09116822483671,
    country: "Costa Rica",
    city: "San Jose",
    avatarImage: "/images/community-images/21-bitcoin-academy.jpg",
    backgroundImage: "/images/community-images/21-bitcoin-academy-bg.jpeg",
  },
  {
    id: "club-satoshi",
    title: "Club Satoshi",
    description:
      "Club Satoshi es la primera comunidad Bitcoiner en Tucumán, Argentina.",
    link: "https://clubsatoshi.notion.site/Club-Satoshi-1500936c4df4808092efe527e111d2c8",
    latitude: -26.83310699095773,
    longitude: -65.2037445223768,
    country: "Argentina",
    city: "Tucumán",
    avatarImage: "/images/community-images/club-satoshi.jpg",
    backgroundImage: "/images/community-images/club-satoshi-bg.jpeg",
    cruzade: true,
    squadId: "escuadroncillo",
  },
  {
    id: "cuba-bitcoin",
    title: "Cuba Bitcoin",
    description:
      "Comunidad Bitcoin Only en Cuba. Educación, meetups, debates en nuestra Patria sobre Bitcoin.",
    link: "https://cubabitcoin.org/",
    latitude: 23.129991782640744,
    longitude: -82.34170792430879,
    country: "Cuba",
    city: "La Habana",
    avatarImage: "/images/community-images/cuba-bitcoin.jpg",
    backgroundImage: "/images/community-images/cuba-bitcoin-bg.jpeg",
    cruzade: true,
    squadId: "escuadron-libertad",
  },
  {
    id: "bitcoin-nea",
    title: "Bitcoin NEA",
    description:
      "Somos una red abierta de entusiastas, desarrolladores, comerciantes y educadores del noreste argentino (Chaco, Corrientes, Formosa y Misiones) que promueve el uso, estudio y adopción de Bitcoin como herramienta de soberanía individual y desarrollo regional.",
    link: "https://chat.whatsapp.com/BSZy2cScQJJIcvwqPAInwB",
    latitude: -27.452219,
    longitude: -58.984194,
    country: "Argentina",
    city: "Resistencia, Chaco",
    avatarImage: "/images/community-images/bitcoin-nea.jpg",
    cruzade: true,
    squadId: "escuadroncillo",
  },
  {
    id: "bitcoin-berlin",
    title: "Bitcoin Berlín SV",
    description:
      "Este proyecto está dedicado a construir una economía de Bitcoin desde la base en la ciudad de Berlín, El Salvador. Nuestra misión es empoderar a la comunidad a través de la educación sobre cómo Bitcoin puede ser utilizado como medio de intercambio, unidad de cuenta y un depósito confiable de valor. Creemos que, a través de una educación dedicada, podemos traer más oportunidades a este pueblo y que esto puede ser el inicio de un futuro transformador para Berlín. Vemos a Berlín como una de las ciudades líderes que están dando forma al futuro.",
    link: "https://www.bitcoinberlinsv.com/",
    latitude: 13.49814,
    longitude: -88.5653058,
    country: "El Salvador",
    city: "Berlín, Usulután",
    avatarImage: "/images/community-images/bitcoin-berlin.jpg",
    backgroundImage: "/images/community-images/bitcoin-berlin-bg.jpeg",
    cruzade: true,
    squadId: "OLF",
  },
  {
    id: "bitcoin-dominicana",
    title: "Bitcoin Dominicana",
    description:
      "Bitcoin Dominicana es la primera comunidad Bitcoin Only de la República Dominicana. Representamos oficialmente a Mi Primer Bitcoin en el país, promoviendo educación financiera con estándares internacionales. Fuimos ganadores del Bitcoin Beach Grant 2024, los primeros en subir negocios dominicanos a BTC Map, e impulsores de la creación de la Asociación de Bitcoin de la República Dominicana. Educación, adopción y circularidad. Hacemos que el Bitcoin funcione aquí y ahora. 🇩🇴⚡",
    link: "https://bitcoindominicana.com/",
    latitude: 18.7357,
    longitude: -70.1627,
    country: "República Dominicana",
    city: "Santo Domingo, La Romana, Santiago, Puerto Plata, La Vega, Higuey, Samana",
    avatarImage: "/images/community-images/bitcoin-dominicana.png",
    backgroundImage: "/images/community-images/bitcoin-dominicana-bg.jpeg",
  },
  {
    id: "bitmaxis",
    title: "BitMaxis",
    description:
      'BitMaxis es una comunidad de bitcoiners ecuatoriana, fundada por Juan Carlos Yturralde en el 2025, que busca expandir los conocimientos sobre Bitcoin y temas relacionados a todo su público junto con reuniones sociales y talleres prácticos entre la comunidad e invitados. Por último, el objetivo más ambicioso de la comunidad es promover la economía circular de Bitcoin en Ecuador a través de un proyecto llamado "Bitcoinización Costera".',
    link: "https://bitmaxis.com",
    latitude: -2.197699394,
    longitude: -79.8918643,
    country: "Ecuador",
    city: "Guayaquil",
    avatarImage: "/images/community-images/bitmaxis.jpg",
  },
  {
    id: "bitcoin-school-argentina",
    title: "Bitcoin School Argentina",
    description:
      '"Educación libre, imparcial e independiente en Argentina. Saber cómo ahorrar es un derecho humano." Somos Nodo Completo (Full Node) de la red educativa de Mi Primer Bitcoin. En breve formamos parte de la red Plan B Network tmb. Se hace meetups semanales, BitDevs mensualmente, co-working, hackerspace, y talleres de autocustodia.',
    link: "https://bitcoinschoolar.com",
    latitude: -31.42462892556743,
    longitude: -64.183004432926,
    country: "Argentina",
    city: "Córdoba",
    avatarImage: "/images/community-images/bitcoin-school-argentina.jpg",
    backgroundImage:
      "/images/community-images/bitcoin-school-argentina-bg.jpeg",
  },
  {
    id: "prospera-distrito-bitcoin",
    title: "Próspera Distrito Bitcoin",
    description:
      "En Próspera, donde el Bitcoin tiene estatus de moneda de curso legal desde 2022, casi un centenar de comercios ya aceptan pagos en BTC: desde restaurantes y cafés hasta hoteles y proveedores de servicios. Aquí nació el Bitcoin District, un espacio que reúne a empresas como Amity Age, Blink y Jan3, junto a una comunidad internacional de constructores, emprendedores y familias que deciden vivir directamente en sats. Más que un barrio, es un movimiento: buscamos que Próspera se convierta en el primer Distrito Bitcoin del mundo, un lugar donde la economía circular no es teoría sino práctica diaria —donde se compran propiedades en BTC, se pagan impuestos en BTC, y se vive con la moneda dura que soñaron los Bitcoiners. Nuestro objetivo es dar vida a Próspera Distrito Bitcoin: un movimiento para forjar la economía circular de Bitcoin más vibrante del planeta aquí, en Roatán.",
    link: "https://thebitcoindistrict.com",
    latitude: 16.3694013,
    longitude: -86.4741987,
    country: "Honduras",
    city: "Próspera, Roatan",
    avatarImage: "/images/community-images/bitcoin-district-prospera.jpg",
    backgroundImage:
      "/images/community-images/bitcoin-district-prospera-bg.jpeg",
    squadId: "el-clan",
    cruzade: true,
    foundation: 2025,
    peopleCount: 20,
  },
  {
    id: "bitcoin-paraguay",
    title: "Bitcoin Paraguay",
    description:
      "Nuestra visión es conectar a las personas interesadas en Bitcoin, intercambiar conocimientos, aumentar la adopción y ayudar a construir economías circulares locales en todo Paraguay.",
    link: "https://bitcoinparaguay.org",
    latitude: -25.3,
    longitude: -57.633333,
    country: "Paraguay",
    city: "Asunción",
    avatarImage: "/images/community-images/bitcoin-paraguay.jpg",
    backgroundImage: "/images/community-images/bitcoin-paraguay-bg.jpeg",
  },
  {
    id: "motiv-peru",
    title: "Motiv Perú",
    description:
      "The ideation and creation of Motiv happened when its co-founders, Rich Swisher and Vali Popescu were dispatched to a remote village high up in the Andes mountains in Peru to work with the local Kechua people to install a playground in front of their schoolhouse. When they encountered children with tragic stories Both Swisher and Popescu discovered the village had become accustomed to losing roughly five out of 100 children each year to various medical conditions stemming from exposure to cold and infection primarily for the lack of shoes. Though this was fixable, it was not being fixed, and nobody stepped in to fix the issue that staring costing children their life which is when Swisher and Popescu created Motiv to help those in need. Founded in July 2020 Motiv, Inc, is now a NGO and Registered 501(c)3 that strives to improve the lives of those less fortunate. The Company does this through programs designed to provide those in need with the opportunity to thrive and survive, by using Bitcoin to help better their lives.",
    link: "https://motiv.ngo/",
    latitude: -8.071963909,
    longitude: -79.1198552126,
    country: "Perú",
    city: "Perú",
    avatarImage: "/images/community-images/motiv-peru.jpg",
    backgroundImage: "/images/community-images/motiv-peru-bg.jpeg",
  },
  {
    id: "orangepill-peru",
    title: "Orange Pill Peru",
    description:
      "Bitcoin Only Plebs Meet Up Group. Organizamos meetups en Lima y otros eventos online como Bitdevs Lima.",
    link: "https://orangepillperu.com",
    latitude: -12.1216250919,
    longitude: -77.0288524853,
    country: "Perú",
    city: "Lima",
    avatarImage: "/images/community-images/orangepill-peru.jpg",
    backgroundImage: "/images/community-images/orangepill-peru-bg.jpeg",
  },
  {
    id: "btc-isla",
    title: "BTC Isla",
    description: "Isla Mujeres en México.",
    link: "https://x.com/btcisla",
    latitude: 21.2372375369028,
    longitude: -86.73512405328384,
    country: "México",
    city: "Isla Mujeres",
    cruzade: true,
    squadId: "OLF",
  },
  {
    id: "escuelita-bitcoin",
    title: "Escuelita Bitcoin",
    description: "Escuelita Bitcoin en Uruguay/Paraguay.",
    link: "https://escuelitabitcoin.com/",
    latitude: -32.971578515599184,
    longitude: -56.18357665782995,
    country: "Uruguay",
    city: "Montevideo",
    cruzade: true,
    squadId: "escuadron-cisne",
  },
  {
    id: "bitcoin-pichilemu",
    title: "Bitcoin Pichilemun",
    description:
      "Somos una pequeña comunidad local de entusiastas y emprendedores potenciando la primera economía circular bitcoiner de Chile en Pichilemu, la capital internacional del surf.",
    link: "https://www.instagram.com/bitcoin.pichilemu/",
    latitude: -34.38777973805733,
    longitude: -72.01717405357795,
    country: "Chile",
    city: "Pichilemu",
    cruzade: false,
  },
  {
    id: "ong-bitcoin-chile",
    title: "ONG Bitcoin Chile",
    description:
      "Somos una comunidad de entusiastas y emprendedores que desde el 2015 educamos y promovemos el uso del Bitcoin en Chile.",
    link: "https://achicrip.org",
    latitude: -33.46448247586844,
    longitude: -70.65249060234349,
    country: "Chile",
    city: "Santiago",
    cruzade: false,
  },
  {
    id: "ong-bitcoin-argentina",
    title: "bitcoin.ar",
    description:
      "Bitcoin.Ar es una ONG que, desde 2013, promueve Bitcoin como tecnología abierta y dinero neutral, impulsando educación, comunidad y adopción para fortalecer soberanía individual, libertad y cooperación voluntaria.",
    link: "https://bitcoin.ar",
    linkTwitter: "https://twitter.com/bitcoinar",
    linkEmail: "info@bitcoin.ar",
    latitude: -34.58596143037415,
    longitude: -58.43216728106237,
    country: "Argentina",
    city: "Buenos Aires",
    cruzade: false,
    avatarImage: "/images/community-images/bitcoin-ar.jpg",
    backgroundImage:
      "https://pbs.twimg.com/profile_banners/310293564/1762443224/1500x500",
  },
];

// Helper functions for filtering
export const getCommunitiesByCountry = (country: string): Community[] => {
  return communities.filter((community) => community.country === country);
};

export const getCommunitiesByCity = (city: string): Community[] => {
  return communities.filter((community) => community.city === city);
};

export const getUniqueCountries = (): string[] => {
  return [...new Set(communities.map((community) => community.country))];
};

export const getUniqueCities = (): string[] => {
  return [
    ...new Set(
      communities
        .map((community) => community.city)
        .filter((city): city is string => Boolean(city))
    ),
  ];
};

export const getCommunityById = (id: string): Community | undefined => {
  return communities.find((community) => community.id === id);
};

export const getCommunitiesByIds = (ids: string[]): Community[] => {
  return communities.filter((community) => ids.includes(community.id));
};

export const getCommunityDomain = (community: Community): string | null => {
  try {
    const url = new URL(community.link);
    return url.hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
};

export const getCommunityByDomain = (
  domain: string
): Community | undefined => {
  return communities.find((community) => {
    const communityDomain = getCommunityDomain(community);
    return communityDomain === domain;
  });
};
